/**
 * Copyright © 2018-present Emu Analytics
 */

import { IPipeline } from './api-interfaces';
import { BaseEndpoints } from './base.endpoints';
import { Client } from './client';
import { PipelineComponentEndpoints } from './pipeline-component.endpoints';

export class PipelineEndpoints extends BaseEndpoints<IPipeline> {
  constructor(client: Client) {
    super(client, 'pipelines');
  }

  components(pipelineId: string) {
    return new PipelineComponentEndpoints(this.client, pipelineId);
  }

  async heartbeat(id: string, params: Record<string, any> = {}): Promise<void> {
    return this.client._post(`${this.resourceEndpoint}/${id}/heartbeat`, { params });
  }

  async publishMetrics(metrics: object, params: Record<string, any> = {}): Promise<void> {
    return this.client._post(`${this.resourceEndpoint}/publish-metrics`, metrics, { params });
  }
}
